import React, { useState } from "react";
import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // install react-icons

const Header = () => {
  const [show, setShow] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const toggleSubmenu = () => setSubmenuOpen(!submenuOpen);

  return (
    <>
      <Navbar
        expand="md"
        style={{ backgroundColor: "#4a90e2" }}
        variant="dark"
        fixed="top"
        className="shadow-sm"
      >
        <Container>
          <Navbar.Brand href="#home" style={{ fontWeight: "bold", fontSize: "1.0rem" }}>
          UMA SWITCHGEAR BHOPAL
           {/*CPAITALIZE  */}
          </Navbar.Brand>

          {/* Hamburger button for mobile */}
          <Button
            variant="outline-light"
            className="d-md-none"
            onClick={handleShow}
            aria-label="Open menu"
            style={{ border: "none" }}
          >
            <span className="navbar-toggler-icon"></span>
          </Button>

          {/* Desktop menu */}
          <Navbar.Collapse className="d-none d-md-flex justify-content-end">
            <Nav>
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#services">Services</Nav.Link>
              <Nav.Link href="#portfolio">Portfolio</Nav.Link>
              <Nav.Link href="#clientsay">Clients Say</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile drawer */}
      <Offcanvas show={show} onHide={handleClose} placement="start" style={{ width: '280px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ fontWeight: 'bold' }}>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link href="#home" onClick={handleClose} className="drawer-link">
              Home
            </Nav.Link>
            <Nav.Link href="#about" onClick={handleClose} className="drawer-link">
              About
            </Nav.Link>

            {/* Services with submenu */}
            <div className="drawer-submenu">
              <div
                className="drawer-link submenu-toggle d-flex justify-content-between align-items-center"
                onClick={toggleSubmenu}
                style={{ cursor: "pointer" }}
              >
                <span>Services</span>
                {submenuOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {submenuOpen && (
                <Nav className="flex-column submenu-items">
                  <Nav.Link
                    href="#service1"
                    onClick={handleClose}
                    className="submenu-link"
                  >
                    Powder Coating
                  </Nav.Link> 
                  <Nav.Link
                    href="#service3"
                    onClick={handleClose}
                    className="submenu-link"
                  >
                    Custom Finishes
                  </Nav.Link>
                </Nav>
              )}
            </div>

            <Nav.Link href="#portfolio" onClick={handleClose} className="drawer-link">
              Portfolio
            </Nav.Link>
            <Nav.Link href="#clientsay" onClick={handleClose} className="drawer-link">
              Clients Say
            </Nav.Link>
            <Nav.Link href="#contact" onClick={handleClose} className="drawer-link">
              Contact
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Styles */}
      <style jsx>{`
        .drawer-link {
          font-weight: 600;
          font-size: 1.1rem;
          padding: 0.75rem 1rem;
          color: #333;
          transition: background 0.3s ease, color 0.3s ease;
          border-radius: 5px;
        }
        .drawer-link:hover {
          background-color: #4a90e2;
          color: white;
        }
        .drawer-submenu {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
        }
        .submenu-toggle {
          font-weight: 600;
          font-size: 1.1rem;
          padding: 0.75rem 1rem;
          border-radius: 5px;
          user-select: none;
          color: #333;
          transition: background 0.3s ease, color 0.3s ease;
        }
        .submenu-toggle:hover {
          background-color: #4a90e2;
          color: white;
        }
        .submenu-items {
          padding-left: 1rem;
          margin-top: 0.3rem;
        }
        .submenu-link {
          font-weight: 500;
          font-size: 1rem;
          padding: 0.5rem 1rem;
          color: #555;
          border-radius: 4px;
          transition: background 0.3s ease, color 0.3s ease;
        }
        .submenu-link:hover {
          background-color: #316ac5;
          color: white;
        }
      `}</style>
    </>
  );
};

export default Header;
